import * as React from "react";
const SvgMessageCircle01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 11.5a7.5 7.5 0 1 0-14.61 2.398c.065.19.145.412.19.63l.032.214.007.168c0 .163-.02.315-.062.484-.069.27-.216.524-.323.722l-1.456 2.695 4.745-.49c.124-.014.286-.033.445-.027a2 2 0 0 1 .373.05c.156.036.327.104.464.157A7.5 7.5 0 0 0 20 11.5m2 0c0 5.247-4.253 9.5-9.5 9.5a9.5 9.5 0 0 1-3.415-.632l-.183-.07c-.038-.013-.032-.01-.01-.005h-.005l-.158.017-5.12.529c-.225.023-.463.048-.66.05-.186.003-.52-.008-.84-.203a1.5 1.5 0 0 1-.702-1.048c-.058-.372.06-.685.133-.856.077-.18.192-.39.299-.589l1.636-3.028c.07-.132.11-.203.135-.256l.003-.008-.006-.024c-.021-.073-.055-.173-.112-.34A9.5 9.5 0 0 1 3 11.5a9.5 9.5 0 0 1 19 0"
}));
export default SvgMessageCircle01;
//# sourceMappingURL=MessageCircle01.js.map